import React from 'react';

import styles from './hotelPlannerLogo.scss';

export interface HotelPlannerLogoProps {
  copy?: string;
}

const HotelPlannerLogo = (props: HotelPlannerLogoProps) => {
  const engineLogoSrc = 'https://media-api.xogrp.com/images/f2b1bf00-e584-4e93-8770-cec493e889b1';

  return (
    <span className={styles.poweredByLink}>
      <div className={styles.poweredByText}>{props.copy}</div>
      <img src={engineLogoSrc} className={styles.hotelPlannerLogo} alt={'Engine'} />
    </span>
  );
};

export default HotelPlannerLogo;
